export function modalImgCreate(setElement) {
  const imgSrc = setElement.getAttribute('src');

  // モーダル内に設置する要素の生成
  const modalCreate = document.createElement('div');
  modalCreate.className = 'c-modal_box';
  modalCreate.innerHTML = '<div class="c-modalImg"><img src="' + imgSrc + '" alt=""></div>';

  return modalCreate;
}
